"use client";

export function clearAllClientState() {
  try {
    localStorage.clear();
  } catch (_) {}
  try {
    sessionStorage.clear();
  } catch (_) {}

  try {
    const past = "Thu, 01 Jan 1970 00:00:00 GMT";
    const cookies =
      typeof document !== "undefined" && document.cookie
        ? document.cookie.split(";")
        : [];

    const host = typeof location !== "undefined" ? location.hostname : "";
    const domains: string[] = [];
    if (host) {
      const parts = host.split(".");
      for (let i = 0; i < parts.length; i++) {
        const domain = parts.slice(i).join(".");
        domains.push(domain);
        domains.push(`.${domain}`);
      }
    }

    cookies.forEach((c) => {
      const eqPos = c.indexOf("=");
      const name = (eqPos > -1 ? c.substring(0, eqPos) : c).trim();
      document.cookie = `${name}=; expires=${past}; path=/`;
      domains.forEach((d) => {
        document.cookie = `${name}=; expires=${past}; path=/; domain=${d}`;
      });
    });
  } catch (_) {}
}

export default clearAllClientState;
